import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "create-order-success" }
const _hoisted_2 = {
  key: 0,
  class: "choice-create-order-success-dialog-content"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/order_success_icon.png",
  alt: ""
}, null, -1)
const _hoisted_5 = { class: "body" }
const _hoisted_6 = { class: "title1" }
const _hoisted_7 = {
  key: 0,
  class: "title2"
}
const _hoisted_8 = { class: "title2" }
const _hoisted_9 = { class: "footer" }
const _hoisted_10 = {
  key: 1,
  class: "choice-create-order-success-dialog-content"
}
const _hoisted_11 = { class: "header" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/order_fail_icon.png",
  alt: ""
}, null, -1)
const _hoisted_13 = { class: "body" }
const _hoisted_14 = { class: "title2" }
const _hoisted_15 = { class: "footer" }

import { t, text } from '@/plugins/i18n'
import { useRtfix } from '@/store'
import { ref } from 'vue'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const router = useRouter()
const isSuccess = ref(false)
const visible = ref(false)
const orderInfo: any = ref({})
const open = (resData: any) => {
  const { data, success } = resData
  isSuccess.value = data[0].success
  visible.value = true
  orderInfo.value = data[0]
}
const jump = () => {
  router.push(useRtfix('OrderInfo', { params: { id: orderInfo.value.platformOrderId } }))
}
expose({
  open
})

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      width: "500",
      "custom-class": "choice-create-order-success-dialog"
    }, {
      default: _withCtx(() => [
        (isSuccess.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("span", null, _toDisplayString(_unref(t)('下单成功')), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('订单已经生成，请关注订单状态')), 1),
                (orderInfo.value.totalFreezeAmount !== orderInfo.value.estimatedTotalOrderPrice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(t)('最新价格为X元').replace('X', orderInfo.value.totalFreezeAmount)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('Choice商品订单为一口价订单，商品单价固定，最终以实际上架数量进行收费，多退少补，请及时关注资金变化。')), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: "submit cursor-pt",
                  onClick: jump
                }, _toDisplayString(_unref(t)('查看订单详情')), 1),
                _createElementVNode("div", {
                  class: "close cursor-pt",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
                }, _toDisplayString(_unref(t)('关闭')), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", null, _toDisplayString(_unref(t)('下单失败')), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(text)[orderInfo.value.code] ?? _unref(t)(orderInfo.value.message)), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: "close cursor-pt",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false))
                }, _toDisplayString(_unref(t)('关闭')), 1)
              ])
            ]))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})